/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { SubTitle, Image, Description, DivRelative, Link } from '../../components/layouts';
import './style.scss';
import { Grid } from 'semantic-ui-react';
import { pureTrans } from '../../helpers';
import { IMAGES } from './resource';

function BlockTitle1() {
  return (
    <>
      <SubTitle>
        孩子拍照总爱动？
        <br />
        没关系
      </SubTitle>
      <Description>聪明的AI智能检测算法在人像模式下检测<br/>儿童场景，记录天生好动的小朋友。</Description>
    </>
  );
}

export default function DesktopContent({ progress, mobile }) {
  const { o1, o2, o3, o4, o5 } = useMemo(
    () => ({
      o1: pureTrans(progress, mobile ? [0.1, 0.25] : [0.2, 0.35], [0.05, 1], 3),
      o2: pureTrans(progress, mobile ? [0.2, 0.35] : [0.2, 0.45], [0.05, 1], 3),
      o3: pureTrans(progress, mobile ? [0.3, 0.45] : [0.3, 0.55], [0.05, 1], 3),
      o4: pureTrans(progress, mobile ? [0.4, 0.55] : [0.4, 0.65], [0.05, 1], 3),
      o5: pureTrans(progress, mobile ? [0.5, 0.65] : [0.5, 0.75], [0.05, 1], 3),
    }),
    [progress]
  );
  // console.log(o1, o2, o3, o4, o5, progress)
  return (
    <div className="child-box" >
      <div className="item item-1" style={{opacity: o1}}>
        <SubTitle>
          孩子拍照总爱动？
          <br />
          没关系
        </SubTitle>
        <Description>聪明的AI智能检测算法在人像模式下检测儿童场景，记录天生好动的小朋友。</Description>
        <Link bordered={false} href="https://shop.vivo.com.cn/product/10006210" text="购买我的X60 Pro+" position={11} />
      </div>
      <div className="item img-item item-2" style={{opacity: o2}}>
        <Image src={IMAGES[1]}/>
      </div>
      <div className="item img-item item-3" style={{opacity: o3}}>
        <Image src={IMAGES[2]}/>
      </div>
      <div className="item img-item item-4" style={{opacity: o4}}>
        <Image src={IMAGES[3]}/>
      </div>
      <div className="item img-item item-5" style={{opacity: o5}}>
        <Image src={IMAGES[4]}/>
      </div>
    </div>
  );
}
